import { SortType } from "../SortType";

export type SwageazyInventoryStockStatus =
  | "in_stock"
  | "out_of_stock"
  | "blocked";

export interface SwageazyInventoryFilters {
  page_no?: number;
  search_text?: string;
  warehouse_id?: string;
  stock_status?: SwageazyInventoryStockStatus | "";
  available_qty_min?: number;
  available_qty_max?: number;
  limit?: number;
  sort_by?: string;
  sort_type?: SortType;
}

export const SWAGEAZY_INVENTORY_STOCK_STATUS_OPTIONS: Array<{
  id: SwageazyInventoryStockStatus | "";
  value: string;
}> = [
  { id: "", value: "All Stock Statuses" },
  { id: "in_stock", value: "In Stock" },
  { id: "out_of_stock", value: "Out of Stock" },
  { id: "blocked", value: "Has Blocked Quantity" },
];

export function resolveInventorySearchText(
  raw: string,
): string | undefined {
  const trimmed = raw.trim();
  if (!trimmed) return undefined;
  if (/^\d+$/.test(trimmed)) return trimmed;
  return trimmed.length >= 3 ? trimmed : undefined;
}

export function parseQtyInput(value: string): number | undefined {
  const trimmed = value.trim();
  if (trimmed === "") return undefined;
  if (!/^\d+$/.test(trimmed)) return undefined;
  return Number(trimmed);
}
